<template>
  <div id="pay" class="container">
    <!-- 支付页面 -->
    <!-- NavBar 导航栏 -->
    <nav-bar class="nav_fixed" rightWidth="16vw" backPath="/myOrder">
      <i slot="left-icon" class="public_icon icon-back"></i>
      <div slot="center">在线支付</div>
    </nav-bar>
    <div class="pay_main">
      <!-- 等待付款 -->
      <!-- <div class="awit_pay" v-if="orderInfo.payEndTime">
        <p class="awit_money"><i class="awit_icon"></i>等待付款</p>
        <p class="awit_down">
          需付款：<span>￥{{ orderInfo.money }}</span>
          <span :style="residue > 0 ? '' : 'color: #ec4a5d'">
            {{ residue > 0 ? "剩余：" : "已延期："
            }}{{ orderInfo.payEndTime ? TimeList(payEndTime) : "" }}</span
          >
        </p>
      </div> -->
      <!-- 缴费类别 -->
      <div class="awit_type">
        <div class="type_title">缴费明细</div>
        <div class="type_money" v-for="item in orderInfo.payCosts">
          <span>{{ item.key }}</span>
          <span>¥{{ item.value }}</span>
        </div>
        <div class="pay-tool">
          <span class="total-text">合计:</span>
          <span class="total-num" v-text="'￥' + orderInfo.money"></span>
        </div>
      </div>
      <!-- 付款方式 -->
      <div class="awit_way">
        <div class="way_chonse">选择支付方式:</div>
        <div class="way_type">
          <span class="pay-way-item">
            <input
              type="radio"
              id="wxpay"
              name="payway"
              value="1"
              v-model="payWayC"
              @change="submitPayway"
            />
            <label for="wxpay"
              ><i class="i-wxpay"></i>微信支付 <i class="tuijian">推荐</i>
            </label>
          </span>
          <span class="pay-way-item">
            <input
              type="radio"
              id="alipay"
              name="payway"
              value="2"
              v-model="payWayC"
              @change="submitPayway"
            />
            <label for="alipay"><i class="i-alipay"></i>支付宝</label>
          </span>
        </div>
      </div>
    </div>
    <!-- 支付按钮 -->
    <div class="pay_btn">
      <button type="button" class="btn-submit" @click="submitHandle">立即支付</button>
    </div>
    <!-- 确认框 -->
    <confirm
      :isTwoOpe="false"
      :message="messageCon"
      :is-show="isShowConfirm"
      @no-click="closeConfirm"
      @yes-click="closeConfirm"
    >
    </confirm>
    <!-- <Foot class="Foot"></Foot> -->
  </div>
</template>

<script>
import Foot from "../../components/Foot.vue";
import NavBar from "components/common/NavBar";
import {
  GetPayCostDetailDto,
  WeiXinNumPay,
  AlipayPayment,
  CreateOrder,
} from "network/pay";
import Confirm from "components/common/confirm/Confirm";
import { userCentresDomain } from "common/const";
import {
  timeFormat,
  alipay_H5,
  countdownFormat,
  countdownFormatOver,
} from "common/utils";

export default {
  name: "Pay",
  components: {
    NavBar,
    Confirm,
    Foot,
  },
  data() {
    return {
      payWayC: 1,
      orderInfo: {
        money: 0,
      },
      payEndTime: "",
      timer: "",
      residue: 0,
      messageCon: "",
      isShowConfirm: false,
      payCostIds: [], //订单id
    };
  },
  computed: {
    // 订单id
    orderId() {
      return this.$route.query.orderId || "";
    },
  },
  created() {
    this.getOrderData(this.orderId);
    var self = this;
    // 倒计时
    this.timer = setInterval(function () {
      // 对每行的剩余时间进行设置
      self.payEndTime = self.TimeList(self.orderInfo.payEndTime);
    }, 1000);
  },
  methods: {
    // 提交订单
    async submitHandle() {
      // 避免重复提交
      if (this.lock) {
        return false;
      }
      // 是否勾选支付方式
      const payway = this.payWayC;
      if (payway <= 0) {
        this.$toast.show("请选择支付方式");
        return false;
      }
      this.lock = true;
      this.$loading.show("");
      // 将支付的订单orderId传到已支付列表页
      this.toPayment(payway);
    },

    // 切换支付方式
    submitPayway() {},
    // 获取订单详情: orderId从缴费列表页传递过来
    async getOrderData(id) {
      let res = await CreateOrder(id);
      console.log(res);
      if (res.code == 1) {
        let result = await GetPayCostDetailDto(res.result);
        if (result.code != 1) {
          this.messageCon = result.message;
          this.isShowConfirm = true;
          return;
        }
        this.orderInfo = result.result;
        this.payCostIds = result.result.orderId;
        // this.payEndTime = result.result.payEndTime;
        // 判断当前数据是已过期还是剩余
        // this.residue = new Date(result.result.payEndTime).getTime() - new Date();
      } else {
        this.$confirm.show(res.message);
        this.$router.back(-1);
      }
    },
    // 调起第三方支付
    async toPayment(payway) {
      let result = "";
      if (payway == 1) {
        // 1微信支付
        let enCode = encodeURIComponent(
          userCentresDomain + "/wechat/Paynotify?orderId=" + this.payCostIds
        );
        console.log(enCode);
        result = await WeiXinNumPay(
          this.payCostIds,
          userCentresDomain + "/myOrder",
          enCode
        );
      } else {
        // 2支付宝支付
        result = await AlipayPayment(
          this.payCostIds,
          userCentresDomain + "/myOrder",
          userCentresDomain + "/myOrder"
        ); // 支付宝
      }
      // this.$loading.hide();
      // this.lock = false;
      if (result && result.code === 1) {
        //微信H5支付
        if (payway == 1) {
          window.location.href = result.message;
          return;
        }
        // 支付宝H5支付
        if (payway == 2) {
          alipay_H5(result.message);
        }
      } else {
        this.$loading.hide();
        this.lock = false;
        let msg = result.message ? result.message : "支付失败";
        this.$confirm.show(msg);
      }
    },
    TimeList: function (itemEnd) {
      var endItem = new Date(itemEnd).getTime(); //获取列表传的截止时间
      var nowItem = new Date().getTime(); //获取当前时间
      var rightTime = Math.floor((endItem - nowItem) / 1000); //截止时间减去当前时间
      if (rightTime > 0) {
        //判断剩余倒计时时间如果大于0就执行倒计时否则就结束
        var AllTime = countdownFormat(rightTime); //公用倒计时方法
        var showTime =
          AllTime.date +
          "天" +
          AllTime.hours +
          "小时" +
          AllTime.minites +
          "分" +
          AllTime.seconds +
          "秒";
        if (AllTime.date == "00") {
          showTime =
            AllTime.hours + "小时" + AllTime.minites + "分" + AllTime.seconds + "秒";
        }
        if (AllTime.hours == "00") {
          showTime = AllTime.minites + "分" + AllTime.seconds + "秒";
        }
      } else if (rightTime < 0) {
        // 已过期
        var AllTime = countdownFormatOver(rightTime); //公用已过期方法
        var showTime =
          AllTime.date +
          "天" +
          AllTime.hours +
          "小时" +
          AllTime.minites +
          "分" +
          AllTime.seconds +
          "秒";
        if (AllTime.date == "00") {
          showTime =
            AllTime.hours + "小时" + AllTime.minites + "分" + AllTime.seconds + "秒";
        }
        if (AllTime.hours == "00") {
          showTime = AllTime.minites + "分" + AllTime.seconds + "秒";
        }
      } else {
        // 防止数据出现NAN或者日期模式
        var showTime = itemEnd;
      }
      return showTime;
    },
    // 关闭确认框
    closeConfirm() {
      console.log("123321");
      this.isShowConfirm = false;
      this.$router.push({ path: "/myOrder" });
    },
  },
  beforeDestroy() {
    // 清除倒计时定时器
    window.clearInterval(this.timer);
  },
};
</script>

<style scoped>
.pay_main {
  padding: 30px 45px 0;
}
.awit_pay {
  margin-bottom: 30px;
}
.awit_money {
  color: #ec4a5d;
  font-size: 32px;
  text-align: center;
  line-height: 50px;
}
.awit_money .awit_icon {
  width: 35px;
  height: 35px;
  margin-top: -6px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
  background: url("../../assets/images/icon_login.png");
  background-size: 750px auto;
  background-position: -523px -461px;
}
.awit_down {
  margin-top: 8px;
  font-size: 28px;
  /* margin-left: 35px; */
  margin-right: 10px;
  line-height: 50px;
  text-align: right;
}
.awit_down span:nth-child(1) {
  margin-right: 30px;
}
.awit_type {
  width: 100%;
  height: auto;
  background: #ffffff;
  border: 1px solid #ebedf0;
  border-radius: 20px;
  margin-bottom: 20px;
}
.awit_type .type_title {
  color: #323233;
  padding-left: 26px;
  font-size: 28px;
  height: 88px;
  line-height: 88px;
  border-bottom: 1px solid #ebedf0;
}
.type_money {
  padding: 0 26px;
  line-height: 82px;
}
.type_money span:nth-child(1) {
  font-size: 24px;
}
.type_money span:nth-child(2) {
  font-size: 32px;
  font-weight: 600;
  color: #ec4a5d;
  float: right;
}
.awit_way {
  width: 100%;
  height: 272px;
  background: #ffffff;
  border: 1px solid #ebedf0;
  border-radius: 20px;
}
.awit_way .way_chonse {
  color: #323233;
  padding-left: 26px;
  font-size: 24px;
  height: 83px;
  line-height: 83px;
  border-bottom: 1px solid #ebedf0;
}
.way_type {
  padding: 0 30px;
}

.way_type span label {
  font-size: 28px;
}

.i-alipay,
.i-wxpay {
  width: 46px;
  height: 50px;
  margin-top: -6px;
  margin-right: 20px;
  display: inline-block;
  vertical-align: middle;
  background: url("../../assets/images/icon_login.png");
  background-size: 750px auto;
}

.i-alipay {
  background-position: -536px -172px;
}

.i-wxpay {
  width: 50px;
  height: 46px;
  background-position: -457px -174px;
}

.pay-way-item {
  position: relative;
  display: block;
}

.pay-way-item label {
  display: block;
  height: 94px;
  line-height: 94px;
}

.pay-way-item input[type="radio"] + label::after {
  content: "\a0";
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #ccc;
  position: absolute;
  right: 0;
  top: 30px;
}

.pay-way-item input[type="radio"]:checked + label::after {
  background-clip: content-box;
  border-color: #5391ff;
  background: #5391ff url("../../assets/images/public_icon.png") no-repeat;
  background-size: 375px auto;
  background-position: -3px -30px;
}

.pay-way-item input[type="radio"] {
  visibility: hidden;
  position: absolute;
  top: 40%;
}

.tuijian {
  display: inline-block;
  width: 64px;
  height: 32px;
  background-color: #fd5252;
  border-radius: 60px;
  font-size: 24px;
  color: #fff;
  line-height: 32px;
  text-align: center;
  margin-left: 8px;
}
/* 立即支付 */
.pay_btn {
  width: 100%;
  height: 120px;
  position: absolute;
  bottom: 0;
  background: #ffffff;
  border-top: 1px solid #ebedf0;
}
.pay_btn .btn-submit {
  width: 85%;
  height: 80px;
  line-height: 80px;
  background: #ec4a5d;
  border-radius: 40px;
  margin: 20px auto;
  margin-left: -34%;
  transform: translate(50%, 0);
  color: #fff;
  font-size: 32px;
}

.pay-tool {
  z-index: 999;
  width: 100%;
  height: 102px;
  border-top: 1px solid #e6e6e6;
  font-size: 0;
  background-color: #fff;
  padding: 0 28px;
  line-height: 102px;
  display: flex;
  justify-content: space-between;
}
.total-text {
  font-size: 28px;
  font-weight: 600;
  /* color: #9e9ea2; */
  vertical-align: middle;
}
.total-num {
  font-size: 32px;
  color: #ec4a5d;
  font-weight: 600;
  text-align: right;
  vertical-align: middle;
}
.modal {
  background-color: none;
}
</style>
